/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OpenAIMessage } from './OpenAIMessage';
import {
    OpenAIMessageFromJSON,
    OpenAIMessageFromJSONTyped,
    OpenAIMessageToJSON,
} from './OpenAIMessage';

/**
 * 
 * @export
 * @interface SavedAIConversation
 */
export interface SavedAIConversation {
    /**
     * 
     * @type {string}
     * @memberof SavedAIConversation
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedAIConversation
     */
    user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedAIConversation
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedAIConversation
     */
    subject?: string;
    /**
     * 
     * @type {Array<OpenAIMessage>}
     * @memberof SavedAIConversation
     */
    messages: Array<OpenAIMessage>;
}

/**
 * Check if a given object implements the SavedAIConversation interface.
 */
export function instanceOfSavedAIConversation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function SavedAIConversationFromJSON(json: any): SavedAIConversation {
    return SavedAIConversationFromJSONTyped(json, false);
}

export function SavedAIConversationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavedAIConversation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'messages': ((json['messages'] as Array<any>).map(OpenAIMessageFromJSON)),
    };
}

export function SavedAIConversationToJSON(value?: SavedAIConversation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_id': value.user_id,
        'patient_id': value.patient_id,
        'subject': value.subject,
        'messages': ((value.messages as Array<any>).map(OpenAIMessageToJSON)),
    };
}

